import { useState } from 'react';

/*
 * The Système U lock-up and page title. The logo is served from /public so a
 * missing file can never break the build; if it fails to load, a plain "U" mark
 * takes its place rather than a broken-image icon.
 */
export function Brand({ title, subtitle }: { title: string; subtitle: string }) {
  const [hasLogo, setHasLogo] = useState(true);
  return (
    <div className="su-brand">
      <div className="su-logo">
        {hasLogo ? <img src="/systeme-u-logo.png" alt="Système U" onError={() => setHasLogo(false)} /> : <span className="su-logo-fallback">U</span>}
      </div>
      <div className="su-title">
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>
    </div>
  );
}
